// extracted by mini-css-extract-plugin
export default {"alert":"l3NI4r"};